import React from 'react';

export const Contact = () => {
  return <h1>This is Contact Page</h1>;
};
